module.exports = __webpack_public_path__ + "static/media/laptop4.fa5528d4.jpg";